import PropTypes from 'prop-types';
import { useEffect, useCallback } from 'react';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
// import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
// import InputAdornment from '@mui/material/InputAdornment';

import { Scrollbar } from '../scrollbar';

// import { useMockedUser } from 'src/auth/hooks';
import Iconify from '../Iconify';

import { ToggleButton } from './styles';
import { ChatNavItem } from './chat-nav-item';
// import { ChatNavItemSkeleton } from './chat-skeleton';
import { useSelector, useDispatch } from '../../redux/store';
import { setSelectedId } from '../../redux/slices/aiConversation';

// ----------------------------------------------------------------------

const NAV_WIDTH = 200;

const NAV_COLLAPSE_WIDTH = 70;

ChatNav.propTypes = {
  collapseNav: PropTypes.object
};

export function ChatNav({ collapseNav }) {
  const dispatch = useDispatch();
  const { list, selectedId } = useSelector((state) => state.aiConversation);

  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  const { openMobile, onOpenMobile, onCloseMobile, onCloseDesktop, collapseDesktop, onCollapseDesktop } = collapseNav;

  // const [searchContacts, setSearchContacts] = useState({ query: '', results: [] });

  // const myContact = useMemo(
  //   () => ({
  //     id: `${user?.id}`,
  //     role: `${user?.role}`,
  //     email: `${user?.email}`,
  //     address: `${user?.address}`,
  //     name: `${user?.displayName}`,
  //     lastActivity: '2 hours ago',
  //     avatarUrl: `${user?.photoURL}`,
  //     phoneNumber: `${user?.phoneNumber}`,
  //     status: 'online'
  //   }),
  //   [user]
  // );

  useEffect(() => {
    if (!mdUp) {
      onCloseDesktop();
    }
  }, [onCloseDesktop, mdUp]);

  const handleToggleNav = useCallback(() => {
    if (mdUp) {
      onCollapseDesktop();
    } else {
      onCloseMobile();
    }
  }, [mdUp, onCloseMobile, onCollapseDesktop]);

  const handleClickCompose = useCallback(() => {
    dispatch(setSelectedId(null));
    if (!mdUp) {
      onCloseMobile();
    }
  }, [dispatch, mdUp, onCloseMobile]);

  // const handleSearchContacts = useCallback(
  //   (inputValue) => {
  //     setSearchContacts((prevState) => ({ ...prevState, query: inputValue }));
  //
  //     if (inputValue) {
  //       const results = contacts.filter((contact) => contact.name.toLowerCase().includes(inputValue.toLowerCase()));
  //
  //       setSearchContacts((prevState) => ({ ...prevState, results }));
  //     }
  //   },
  //   [contacts]
  // );

  // const handleClickAwaySearch = useCallback(() => {
  //   setSearchContacts({ query: '', results: [] });
  // }, []);

  // const renderLoading = () => <ChatNavItemSkeleton />;

  const renderList = () => (
    <nav>
      <Box component="ul">
        {list.map((conv) => (
          <ChatNavItem
            key={conv.id}
            collapse={collapseDesktop}
            conversation={conv}
            selected={conv.id === selectedId}
            onSelectConversation={() => {
              dispatch(setSelectedId(conv.id));
              if (!mdUp) {
                onCloseMobile();
              }
            }}
          />
        ))}
      </Box>
    </nav>
  );

  const renderContent = () => (
    <>
      <Box
        sx={{
          p: 2.5,
          pb: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {!collapseDesktop && (
          <>
            <Box sx={{ flexGrow: 1 }} />
          </>
        )}

        <IconButton onClick={handleToggleNav}>
          <Iconify icon={collapseDesktop ? 'eva:arrow-ios-forward-fill' : 'eva:arrow-ios-back-fill'} />
        </IconButton>

        {!collapseDesktop && (
          <IconButton onClick={handleClickCompose}>
            <Iconify width={24} icon="ri:chat-new-line" />
          </IconButton>
        )}
      </Box>

      {<Scrollbar sx={{ pb: 1 }}>{renderList()}</Scrollbar>}
    </>
  );

  return (
    <>
      <ToggleButton onClick={onOpenMobile} sx={{ display: { md: 'none' } }}>
        <Iconify width={16} icon="solar:users-group-rounded-bold" />
      </ToggleButton>

      <Box
        sx={{
          minHeight: 0,
          flex: '1 1 auto',
          width: NAV_WIDTH,
          flexDirection: 'column',
          display: { xs: 'none', md: 'flex' },
          borderRight: `solid 1px ${theme.palette.divider}`,
          transition: theme.transitions.create(['width'], {
            duration: theme.transitions.duration.shorter
          }),
          ...(collapseDesktop && { width: NAV_COLLAPSE_WIDTH })
        }}
      >
        {renderContent()}
      </Box>

      <Drawer
        open={openMobile}
        onClose={onCloseMobile}
        slotProps={{ backdrop: { invisible: true } }}
        PaperProps={{ sx: { width: NAV_WIDTH } }}
      >
        {renderContent()}
      </Drawer>
    </>
  );
}
